



















































































































import {Vue, Prop, Component} from "vue-property-decorator";
import Tooltip from "../components/Tooltip.vue";
import {MitigationType, ServiceType} from "@/types/riskPrioritization.type";

@Component({components: {Tooltip}})
export default class Mitigations extends Vue {
    @Prop() question!: any;
    @Prop() confidentialityTier!: any;
    @Prop() availabilityTier!: any;
    @Prop() tabName!: any;

    mounted() {
        this.showMitigationHeaders();
    }

    mitigations: MitigationType[] = [
        {
            name: "Access",
            show: false,
            items: [
                {
                    text:
                        "Use an Intrusion Protection System and/or Intrusion Detection System",
                    showMitigation: this.question.accessQuestions.questions
                        .anyIPS.showMitigation,
                    tooltip:
                        "An Intrustion Prevention System (IPS) is a cybersecurity tool that monitors network traffic flow to identify malicious activity.",
                    link: "https://www.cisecurity.org/controls/boundary-defense"
                },
                {
                    text: "Start adding IPs to the ‘Allow List’",
                    showMitigation: this.question.accessQuestions.questions
                        .allowList.showMitigation,
                    tooltip:
                        "Add IPs to the ‘Allow List’: A security feature that controls network access by identifying and authorizing a list of trusted Internet Protocol (IP) addresses.",
                    link:
                        "https://www.cisecurity.org/controls/inventory-and-control-of-software-assets/"
                },
                {
                    text: "Use better encryption (WPA2)",
                    showMitigation: this.question.accessQuestions.questions.wpa2
                        .showMitigation,
                    tooltip:
                        "Wifi-Protected Access 2 (WPA2) is an encryption protocol that helps to secure wireless networks and is a replacement for Wifi-Protected Access (WPA) and Wired Equivalent Privacy (WEP)",
                    link:
                        "https://www.cisecurity.org/controls/wireless-access-control/"
                },
                {
                    text: "Disable remote access from unauthenticated users",
                    showMitigation: this.question.accessQuestions.questions
                        .remoteAccessNoAuth.showMitigation,
                    tooltip: null,
                    link: "https://us-cert.cisa.gov/Ransomware"
                },
                {
                    text: "Enact removable media policy",
                    showMitigation: this.question.accessQuestions.questions
                        .removableMediaPolicy.showMitigation,
                    tooltip: null,
                    link: "https://www.cisecurity.org/controls/data-protection/"
                }
            ]
        },
        {
            name: "Authentication",
            show: false,
            items: [
                {
                    text: "Use multi-factor authentication (MFA)",
                    showMitigation: this.question.authQuestions.questions
                        .anyAuth.showMitigation,
                    tooltip:
                        "Multi-Factor Authorization (MFA) includes having a code sent through SMS/text message to confirm authentication",
                    link:
                        "https://www.cisa.gov/sites/default/files/publications/cisa-multi-factor-authentication.pdf "
                },
                {
                    text:
                        "Use physical objects for multi-factor authentication (MFA)",
                    showMitigation: this.question.authQuestions.questions.tfa
                        .showMitigation,
                    tooltip: null,
                    link:
                        "https://www.cisa.gov/sites/default/files/publications/cisa-multi-factor-authentication.pdf"
                }
            ]
        },
        {
            name: "Hardware Management",
            show: false,
            items: [
                {
                    text: "Patch server regularly",
                    showMitigation:
                        this.question.hardwareQuestions.questions.patchHardware
                            .showMitigation ||
                        this.question.hardwareQuestions.questions
                            .patchHardwareElection.showMitigation,
                    tooltip: null,
                    link:
                        "https://www.cisecurity.org/controls/continuous-vulnerability-management/"
                }
            ]
        },
        {
            name: "Software Management",
            show: false,
            items: [
                {
                    text: "Patch software regularly",
                    showMitigation:
                        this.question.softwareQuestions.questions.patchSoftware
                            .showMitigation ||
                        this.question.softwareQuestions.questions
                            .patchSoftwareElection.showMitigation,
                    tooltip: null,
                    link:
                        "https://www.cisecurity.org/controls/continuous-vulnerability-management/"
                }
            ]
        },
        {
            name: "DDoS Protection",
            show: false,
            items: [
                {
                    text: "Implement DDoS protection",
                    showMitigation: this.question.ddosQuestions.questions
                        .ddosProtection.showMitigation,
                    tooltip:
                        "Implement Distributed Denial-of-Service (DDoS) protections to mitigate the consequences of DDoS attacks",
                    link:
                        "https://us-cert.cisa.gov/sites/default/files/publications/DDoS%20Quick%20Guide.pdf"
                }
            ]
        }
    ];

    //***************** INFO: this services array is the links under "suggested services" ****************** /
    recommendedServices: ServiceType[] = [
        {
            text: "Vulnerability Scanning",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=10",
            showService:
                // always show this service for these tabs:
                this.tabName == "Voter Registration" ||
                this.tabName == "Aggregation (State)" ||
                this.tabName == "Website" ||
                // show service if Networked is clicked
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Networked") ||
                // show service if on these specific tabs, remote access is "yes":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "Yes")
                    ? true
                    : false
        },
        {
            text: "Remote Penetration Testing",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=10",
            showService:
                // always show this service for these tabs:
                this.tabName == "Voter Registration" ||
                this.tabName == "Aggregation (State)" ||
                this.tabName == "Website" ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Networked") ||
                // show service if on these specific tabs, remote access is "yes":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "Yes") ||
                this.question.accessQuestions.questions.proximateAccess
                    .userInput.answer === "Yes"
                    ? true
                    : false
        },
        {
            text: "Phishing Campaign Assessment",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=9",
            showService:
                // always show this service for these tabs:
                this.tabName == "Voter Registration" ||
                this.tabName == "Aggregation (State)" ||
                this.tabName == "Website" ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Networked") ||
                // show service if on these specific tabs, remote access is "yes":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "Yes") ||
                this.question.authQuestions.questions.anyAuth.userInput
                    .answer === "No" ||
                this.question.authQuestions.questions.sfa.userInput.answer ===
                    "Yes"
                    ? true
                    : false
        },
        {
            text: "Enhanced Cybersecurity Services",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=13",
            showService:
                // always show this service for these tabs:
                this.tabName == "Voter Registration" ||
                this.tabName == "Aggregation (State)" ||
                this.tabName == "Website" ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Networked") ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Non-Networked") ||
                // show service if on these specific tabs, remote access is "yes":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "Yes") ||
                // show service if on these specific tabs, remote access is "no":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "No")
                    ? true
                    : false
        },
        {
            text: "Risk and Vulnerability Assessment",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=9",
            showService:
                // always show this service for these tabs:
                this.tabName == "Voter Registration" ||
                this.tabName == "Aggregation (State)" ||
                this.tabName == "Website" ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Networked") ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Non-Networked") ||
                // show service if on these specific tabs, remote access is "yes":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "Yes") ||
                // show service if on these specific tabs, remote access is "no":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "No")
                    ? true
                    : false
        },
        {
            text: "Continuous Diagnostics and Mitigation",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=12",
            showService:
                // always show this service for these tabs:
                this.tabName == "Voter Registration" ||
                this.tabName == "Aggregation (State)" ||
                this.tabName == "Website" ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Networked") ||
                // show service if on these specific tabs, remote access is "yes":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "Yes")
                    ? true
                    : false
        },
        {
            text: "Validated Architecture Design Review",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=11",
            showService:
                // always show this service for these tabs:
                this.tabName == "Voter Registration" ||
                this.tabName == "Aggregation (State)" ||
                this.tabName == "Website" ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Networked") ||
                // show service if on these specific tabs, remote access is "yes":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "Yes")
                    ? true
                    : false
        },
        {
            text: "Cyber Resilience Review",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=6",
            showService:
                // always show this service for these tabs:
                this.tabName == "Voter Registration" ||
                this.tabName == "Aggregation (State)" ||
                this.tabName == "Website" ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Networked") ||
                // show service if on these specific tabs, remote access is "yes":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "Yes") ||
                this.confidentialityTier >= 2 ||
                this.availabilityTier >= 2
                    ? true
                    : false
        },
        {
            text: "Cyber Infrastructure Survey",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=8",
            showService:
                // always show this service for these tabs:
                this.tabName == "Voter Registration" ||
                this.tabName == "Aggregation (State)" ||
                this.tabName == "Website" ||
                (this.question.scaleQuestions.questions
                    .networkedOrNonNetworked &&
                    this.question.scaleQuestions.questions
                        .networkedOrNonNetworked.userInput.answer ===
                        "Networked") ||
                // show service if on these specific tabs, remote access is "yes":
                ((this.tabName === "Pollbook Preparation" ||
                    this.tabName === "Ballot Preparation" ||
                    this.tabName === "Voting Machine Preparation" ||
                    this.tabName === "Tabulation Use (Precinct)" ||
                    this.tabName === "Tabulation Use (Central)") &&
                    this.question.accessQuestions.questions.remoteAccess
                        .userInput.answer === "Yes") ||
                this.confidentialityTier >= 2 ||
                this.availabilityTier >= 2
                    ? true
                    : false
        }
    ];

    additionalServices: ServiceType[] = [
        //***************** INFO: these objects are the 9 that show all the time for each tab *****************/
        {
            text: "Join the EI-ISAC",
            link: "https://learn.cisecurity.org/ei-isac-registration",
            showService: true
        },
        {
            text: "Last Mile Posters",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=20",
            showService: true
        },
        {
            text: "Cybersecurity Exercises",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=22",
            showService: true
        },
        {
            text: "External Dependencies Management Assessment",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=8",
            showService: true
        },
        {
            text: "Automated Indicator Sharing",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=17",
            showService: true
        },
        {
            text: "Homeland Security Information Network",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=17",
            showService: true
        },
        {
            text: "National Cyber Awareness System",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=19",
            showService: true
        },

        {
            text: "National Initiative for Cybersecurity Careers and Studies",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=22",
            showService: true
        },
        {
            text: "Federal Virtual Training Environment",
            link:
                "https://www.cisa.gov/sites/default/files/publications/cisa_election-security-resources-guide-Sept-2020.pdf#page=24",
            showService: true
        }
    ];

    showMitigationHeaders() {
        this.mitigations.forEach((mitigation: any) => {
            mitigation.show === false;
            mitigation.items.forEach((item: any) => {
                if (item.showMitigation) {
                    mitigation.show = true;
                }
            });
        });
    }

    get recServiceTotal() {
        let total = 0;
        this.recommendedServices.forEach((service: any) => {
            if (service.showService) {
                total++;
            }
        });
        return total;
    }

    get showRecLinks(): any {
        let isShown = true;
        this.recommendedServices.forEach((service: any) => {
            if (service.showService) {
                isShown = false;
            }
        });
        return isShown;
    }

    get additServiceTotal() {
        let total = 0;
        this.additionalServices.forEach((service: any) => {
            if (service.showService) {
                total++;
            }
        });
        return total;
    }

    get mitigationTotal() {
        let total = 0;
        this.mitigations.forEach((mitigation: any) => {
            mitigation.items.forEach((item: any) => {
                if (item.showMitigation) {
                    total++;
                }
            });
        });
        return total;
    }

    get showMitigations(): any {
        let isShown = true;
        this.mitigations.forEach((mitigation: any) => {
            if (mitigation.show) {
                isShown = false;
            }
        });
        return isShown;
    }
}
